if (!customElements.get('oc-drill-variant-picker')) {
  customElements.define(
    'oc-drill-variant-picker',
    class extends HTMLElement {
      connectedCallback() {
        if (this.initialized || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        this.ui = this.querySelector('[data-drill-ui]');
        this.native = this.querySelector('[data-drill-native]');
        this.trigger = this.querySelector('[data-drill-trigger]');
        this.dialog = this.querySelector('[data-drill-dialog]');
        this.variants = JSON.parse(this.querySelector('[data-drill-variants]').textContent);
        if (!this.dialog?.showModal || !this.native.querySelector('variant-selects')) return;

        this.initialized = true;
        this.onClick = this.handleClick.bind(this);
        this.onDialogClose = () => {
          this.trigger.setAttribute('aria-expanded', 'false');
          this.trigger.focus({ preventScroll: true });
        };
        this.addEventListener('click', this.onClick);
        this.dialog.addEventListener('close', this.onDialogClose);
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
        this.native.hidden = true;
        this.ui.hidden = false;
        this.updateSelection(this.dataset.selectedId);
      }

      disconnectedCallback() {
        this.unsubscribe?.();
        clearTimeout(this.loadingTimeout);
        this.removeEventListener('click', this.onClick);
        this.dialog?.removeEventListener('close', this.onDialogClose);
        this.dialog?.close();
        this.initialized = false;
      }

      handleClick(event) {
        const target = event.target;
        if (target.closest('[data-drill-trigger]')) {
          if (this.loading) return;
          this.dialog.showModal();
          this.trigger.setAttribute('aria-expanded', 'true');
          this.dialog.querySelector('[aria-pressed="true"]')?.focus({ preventScroll: true });
        } else if (target.closest('[data-drill-close]')) {
          this.dialog.close();
        } else if (target.closest('[data-drill-variant]')) {
          this.selectVariant(target.closest('[data-drill-variant]').dataset.drillVariant);
        } else if (target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
            this.dialog.close();
          }
        }
      }

      selectVariant(id) {
        if (String(id) === this.dataset.selectedId && this.querySelector('[data-drill-error]').hidden) {
          this.dialog.close();
          return;
        }

        const variant = this.variants.find((item) => String(item.id) === String(id));
        const nativePicker = this.native.querySelector('variant-selects');
        const groups = Array.from(nativePicker?.querySelectorAll('.product-form__input') || []);
        const controls = variant?.options.map((value, index) => {
          const group = groups[index];
          const select = group?.querySelector('select');
          const control = Array.from(group?.querySelectorAll('input[type="radio"], option') || []).find(
            (item) => item.value === value
          );
          return { select, control };
        });

        if (!controls?.length || controls.some(({ control }) => !control)) {
          this.dialog.close();
          this.showError();
          return;
        }

        let changedControl;
        controls.forEach(({ select, control }) => {
          if (select) {
            select.value = control.value;
            Array.from(select.options).forEach((option) => option.toggleAttribute('selected', option === control));
            changedControl = select;
          } else {
            control.checked = true;
            changedControl = control;
          }
        });

        this.setLoading(true);
        this.dialog.close();
        this.loadingTimeout = setTimeout(() => {
          this.setLoading(false);
          this.showError();
        }, 10000);
        changedControl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      handleVariantChange({ data }) {
        if (String(data.sectionId) !== this.dataset.section) return;

        clearTimeout(this.loadingTimeout);
        const updatedPicker = data.html?.getElementById(this.id);
        const updatedVariants = updatedPicker?.querySelector('[data-drill-variants]');
        if (updatedVariants) this.variants = JSON.parse(updatedVariants.textContent);
        this.setLoading(false);
        if (!data.variant) {
          this.showError();
          return;
        }

        this.updateSelection(data.variant.id);
      }

      updateSelection(id) {
        const selected = this.variants.find((variant) => String(variant.id) === String(id));
        if (!selected) return;

        this.dataset.selectedId = String(selected.id);
        this.querySelector('[data-drill-title]').textContent = selected.title;
        this.querySelector('[data-drill-price]').textContent = selected.price;
        const image = this.querySelector('[data-drill-image]');
        if (image && selected.image) image.src = selected.image;
        this.querySelectorAll('[data-drill-variant]').forEach((button) => {
          const variant = this.variants.find((item) => String(item.id) === button.dataset.drillVariant);
          button.setAttribute('aria-pressed', String(button.dataset.drillVariant === String(selected.id)));
          if (variant) {
            button.querySelector('.oc-drill-picker__price').textContent = variant.price;
            const stock = button.querySelector('.oc-drill-picker__stock');
            stock.textContent = variant.available ? this.dataset.available : this.dataset.unavailable;
            stock.classList.toggle('oc-drill-picker__stock--unavailable', !variant.available);
          }
        });

        const availability = this.querySelector('[data-drill-availability]');
        availability.hidden = selected.available;
        availability.textContent = this.variants.some((variant) => variant.available)
          ? this.dataset.otherOptions
          : this.dataset.allUnavailable;
        this.querySelector('[data-drill-error]').hidden = true;
      }

      setLoading(loading) {
        this.loading = loading;
        this.trigger.setAttribute('aria-disabled', String(loading));
        this.trigger.setAttribute('aria-busy', String(loading));
        if (loading) this.querySelector('[data-drill-error]').hidden = true;
      }

      showError() {
        const error = this.querySelector('[data-drill-error]');
        error.textContent = this.dataset.loadingError;
        error.hidden = false;
      }
    }
  );
}
